<template>
  <section :class="$style.sectionRoot">
    <header
      :class="$style.sectionHeader"
    >
      VPN Configuration
    </header>

    <fieldset :class="$style.fieldset">
      <section>
        <InputLabel
          :class="$style.heading"
          name="isVPNEnabled"
          text="VPN Enabled"
        />

        <Checkbox
          id="isVPNEnabled"
          v-model="model.attributes.vpn.enabled"
          label="Enable VPN access for this Group"
          @input="update"
        />
      </section>

      <section
        v-if="model.attributes.vpn.enabled"
        class="grantTypes"
      >
        <legend>
          <HeadingSmall
            :class="$style.heading"
            element="h4"
          >
            Inbound VPN Access Groups
          </HeadingSmall>
        </legend>

        <header>
          <ParagraphBody>
            Setup allowed inbound connections from groups.
          </ParagraphBody>
        </header>

        <div
          v-for="_, index in model.attributes.vpn.rules"
          :key="index"
          :class="$style.vpnGroupContainer"
        >
          <Select
            ref="selJCName"
            v-model="model.attributes.vpn.rules[index].groups[0]"
            ariaLabel="JumpCloud Attribute Name"
            :class="$style.groupSelect"
            :name="`jc-name-select-${index}`"
            :options="systemGroupOptions"
            required
            @input="update"
          />

          <IconButton
            ref="btnRemoveUri"
            :ariaLabel="`Remove group ${index + 1}`"
            hasNoBackground
            icon="delete"
            informational
            @click="() => removeVpnAccess(index)"
          />
        </div>

        <IconButton
          hasNoBackground
          icon="add"
          informational
          matchText
          text="Add Group"
          @click="addVpnAccess"
        />
      </section>
    </fieldset>
  </section>
</template>

<script>
import {
  Checkbox,
  HeadingSmall,
  IconButton,
  InputLabel,
  ParagraphBody,
  Select,
} from '@jumpcloud/ui-components';
import { ItemTypeConsts, StoreModelMap, StoreModuleMap } from 'client/util/Constants';
import { cloneDeep } from 'lodash';
import { mapActions, mapGetters } from 'vuex';

const systemGroupModel = StoreModelMap[ItemTypeConsts.systemGroup];
const systemGroupCollection = StoreModuleMap[ItemTypeConsts.systemGroup];

export default {
  name: 'SystemGroupVPN',

  components: {
    Checkbox,
    HeadingSmall,
    IconButton,
    InputLabel,
    ParagraphBody,
    Select,
  },

  data() {
    return {
      systemGroupOptions: [],
      model: {},
    };
  },

  computed: {
    ...mapGetters(systemGroupModel, [
      'item',
    ]),

    ...mapGetters(systemGroupCollection, [
      'getCollection',
    ]),
  },

  created() {
    const model = cloneDeep(this.item);
    model.attributes = model.attributes || {};
    model.attributes.vpn = model.attributes.vpn || { rules: [] };
    this.model = model;

    this.systemGroupOptions = this.getCollection
      .map(val => ({ name: val.name, value: val.id }));
  },

  methods: {
    ...mapActions(systemGroupModel, [
      'updateItem',
    ]),

    addVpnAccess() {
      this.model.attributes.vpn.rules.push({ groups: [''] });
    },

    removeVpnAccess(index) {
      this.model.attributes.vpn.rules.splice(index, 1);
      this.updateItem(cloneDeep(this.model));
    },

    update() {
      this.updateItem(cloneDeep(this.model));
    },
  },
};
</script>

<style module>
@import '../../css/sections.css';

.fieldset section {
  margin: 30px 0;
}

.heading {
  /* hmm. do we nee important? */
  font-size: var(--jc-size-0p875) !important;
}

.vpnGroupContainer {
  display: flex;
}

.vpnGroupContainer .groupSelect {
  width: 500px;
}
</style>
